<template lang="pug">
.grey.pb-5
  b-container
    b-row(class="justify-content-md-center")
      b-col.text-center(cols="12" lg="7")
        Message(
          :fontSizes="[40, 20]"
          title="Our Team"
          subtitle="Our team has considerable experience in sectors including Private Equity, Consulting, Data Science and Software development. "
        )
      b-col(cols="12" lg="6" v-for="(w, i) of workers" :key="i")
        Worker(
          :title="w.title"
          :subtitle="w.description"
          :icon="w.img"
        )
</template>

<script>
import Message from '@/components/Shared/Message.vue'
import Worker from '@/components/About/Worker.vue'

export default {
  name: 'Team',
  components: {
    Message,
    Worker
  },
  data () {
    return {
      workers: [
        {
          img: 'Idriss-Soumare.jpg',
          title: 'Idriss Soumare - Founder, CEO',
          description: 'Idriss started his career at McKinsey & Co. in Paris where he focused on Financial Institutions and Industrials. He later joined BC Partners, a large cap Private Equity firm where he stayed 12 years (of which 3 as partner) in Paris, New York and London. While at BC, Idriss was part of teams investing in 6 companies for a combined EV of c. $7bn. He was an active member of 4 boards across numerous sectors (retail, industrials, professional services and healthcare). Idriss holds an Msc. in Applied Mathematics from Ecole Centrale Paris.'
        },
        {
          img: 'Alexey-Belovs.png',
          title: 'Alexey Belovs - Head of Development',
          description: 'Alexey spent 7 years at ThoughtWorks, one of the UK’s leading software development consultancies where he was exposed to a multitude of projects and tech stacks. Since then, Alexey has been working as a tech lead in several projects, coordinating scoping, architecture design, team staffing and product delivery. Lately, Alexey worked for Vocalink as they seek to modernize their payment processing platform and related client interfaces. Alexey holds a Bsc. in Computer Science from the University of Wales.'
        },
        {
          img: 'Andreas-Bjorklund.jpg',
          title: 'Andreas Björklund Nelson - Head of Operations',
          description: 'Andreas worked for 13 years at Accenture as a management consultant. In his role, he served the leadership teams of global Financial Services organizations in a number of engagements in the UK and Continental Europe. He led teams using a data-centric approach to address client challenges including market entry, growth strategy, activity portfolio rationalization, as well as operational and service quality improvements. Andreas holds a Master of Business Administration at the Stockholm University.'
        },
        {
          img: 'Nikolajs-Precenieks.jpg',
          title: 'Nikolajs Precenieks - Software Development',
          description: 'Nikolajs worked as a full-stack developer for a number of companies in London, including Firmstep who provide around 30% of local governments in the UK with CRMs for their city council websites. He holds a Bsc. in Physics from the University of Glasgow.'
        },
        {
          img: 'Ksenia-Kanishcheva.jpg',
          title: 'Ksenia Kanishcheva - Software Development',
          description: 'After graduating, Ksenia joined ekimetrics, a Paris-based data analytics start-up, as a product engineer. She later joined Madumbo, a French start-up providing AI solutions to automate websites testing, as a lead developer. Madumbo was acquired by scale-up Datadog in 2018. Ksenia has since been involved in a number of projects as a full-stack developer through the elite freelance platform Toptal. She holds an Msc. in Finance From Ecole Polytechnique.'
        },
        {
          img: 'Carli-Deysel.png',
          title: 'Carli Deysel – Head of Product',
          description: 'Carli has worked across all roles within Product Development, starting as a Software Engineer, before joining ThoughtWorks in 2005. There she worked in various roles over her 10 years, including setting up large programmes of work. After ThoughtWorks, she has been in engineering leadership roles (including Strategy & VP Engineering) at start-ups. Most recently, at Instana, who were acquired by IBM.'
        }
      ]
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
